import React from "react";
import { Route, Switch } from "react-router-dom";
import Home from "Pages/public/home";
import Login from "Pages/public/login";
import Signup from "Pages/public/signup";
import ConfirmEmail from "Pages/public/confirm-email";
import ForgotPassoword from "Pages/public/forgot-password";
import ResetPassword from "Pages/public/reset-password";
import PrivateLayoutRoute from "./private/layout";

export default function AppRoutes() {
  return (
    <Switch>
      <Route
        path="/login"
        exact={true}
        component={Login}
        layoutProps={{ showFooter: false, showHeader: false }}
      />
      <Route
        path="/signup"
        exact={true}
        component={Signup}
        layoutProps={{ showFooter: false, showHeader: false }}
      />
      <Route path="/confirm-email" component={ConfirmEmail} exact={true} />
      <Route path="/forgot-password" component={ForgotPassoword} exact={true} />
      <Route path="/reset-password" component={ResetPassword} exact={true} />
      <PrivateLayoutRoute path="/panel" />
      <Route path="" component={Home} exact={true} />
    </Switch>
  );
}
